// Toast Plugin para Vue 3
import { reactive } from 'vue'

const toastState = reactive({
  toasts: []
})

let toastId = 0

const toastPlugin = {
  install(app) {
    const toast = {
      success(message, options = {}) {
        this.show('success', message, options)
      },
      
      error(message, options = {}) {
        this.show('error', message, options)
      },
      
      warning(message, options = {}) {
        this.show('warning', message, options)
      },
      
      info(message, options = {}) {
        this.show('info', message, options)
      },
      
      show(type, message, options = {}) {
        const id = ++toastId
        const duration = options.duration || (type === 'error' ? 5000 : 3000)
        
        const toastItem = {
          id,
          type,
          message,
          ...options
        }
        
        toastState.toasts.push(toastItem)
        
        // Auto remove toast after duration
        if (duration > 0) {
          setTimeout(() => {
            this.remove(id)
          }, duration)
        }
        
        return id
      },
      
      remove(id) {
        const index = toastState.toasts.findIndex(toast => toast.id === id)
        if (index > -1) {
          toastState.toasts.splice(index, 1)
        }
      },
      
      clear() {
        toastState.toasts.splice(0)
      }
    }
    
    // Provide toast state for components
    app.provide('toastState', toastState)
    
    // Global property
    app.config.globalProperties.$toast = toast
    
    // Composition API
    app.provide('toast', toast)
  }
}

export default toastPlugin
export { toastState }
